<script lang="ts">
	import { Card, P, Spinner } from 'flowbite-svelte';
	import { onMount } from 'svelte';
	import PageHeader from '../components/PageHeader.svelte';
	import StatusOverview from '../components/StatusOverview.svelte';
	import AbstractID from '../AbstractID';
	import { listUsers, listAuditLogs } from '../AppNetwork';
	import site from '../site';

	let userCount = 0;
	let auditCount = 0;
	let recentLogins = 0;
	let loading = true;

	onMount(async () => {
		try {
			if (AbstractID.isAdministrator) {
				const [usersResult, auditResult] = await Promise.all([
					listUsers({ limit: 1 }),
					listAuditLogs({ limit: 50 })
				]);
				userCount = usersResult.total;
				auditCount = auditResult.total;

				const oneDayAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);
				recentLogins = auditResult.items.filter(
					(e) => e.action === 'USER_LOGIN' && new Date(e.creationDate) > oneDayAgo
				).length;
			}
		} catch (err) {
			console.error('Dashboard stats error:', err);
		} finally {
			loading = false;
		}
	});
</script>

<PageHeader title="Dashboard" description="Live service status for {site.name}" />

{#if AbstractID.isAdministrator}
	<div class="grid gap-6 md:grid-cols-3 mb-8">
		<Card class="max-w-none">
			<div class="flex items-center gap-4">
				<div class="p-3 bg-green-100 dark:bg-green-900/30 rounded-lg">
					<i class="fa-solid fa-users text-2xl text-green-600 dark:text-green-400"></i>
				</div>
				<div>
					<P class="text-sm text-gray-500 dark:text-gray-400">Users</P>
					<p class="text-2xl font-bold text-gray-900 dark:text-white">
						{#if loading}<Spinner size="5" />{:else}{userCount}{/if}
					</p>
				</div>
			</div>
		</Card>

		<Card class="max-w-none">
			<div class="flex items-center gap-4">
				<div class="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
					<i class="fa-solid fa-right-to-bracket text-2xl text-blue-600 dark:text-blue-400"></i>
				</div>
				<div>
					<P class="text-sm text-gray-500 dark:text-gray-400">Logins (24h)</P>
					<p class="text-2xl font-bold text-gray-900 dark:text-white">
						{#if loading}<Spinner size="5" />{:else}{recentLogins}{/if}
					</p>
				</div>
			</div>
		</Card>

		<Card class="max-w-none">
			<div class="flex items-center gap-4">
				<div class="p-3 bg-purple-100 dark:bg-purple-900/30 rounded-lg">
					<i class="fa-solid fa-clipboard-list text-2xl text-purple-600 dark:text-purple-400"></i>
				</div>
				<div>
					<P class="text-sm text-gray-500 dark:text-gray-400">Audit Entries</P>
					<p class="text-2xl font-bold text-gray-900 dark:text-white">
						{#if loading}<Spinner size="5" />{:else}{auditCount}{/if}
					</p>
				</div>
			</div>
		</Card>
	</div>
{/if}

<StatusOverview />
